import { IconButton } from 'components/atoms/IconButton';
import {
  CloseIcon,
  ErrorIconRound,
  InfoIcon,
  SuccessIcon,
  WarningIcon,
} from 'components/atoms/Icons';
import { Stack } from 'components/atoms/Stack';
import Text from '../Text';
import * as Styled from './Toast.styled';
import type { ToastProps, ToastType } from './types';

export const TOAST_DURATION = 5000; // In milliseconds

const ToastMessage = ({
  title,
  description,
  actionButton,
}: Pick<ToastProps, 'title' | 'description' | 'actionButton'>) => {
  return (
    <Styled.MessageContainer>
      <Text data-test-id="toast-title" font="body" variant="headerRegular">
        {title}
      </Text>
      {description && (
        <Text data-test-id="toast-description" font="body" variant="body">
          {description}
        </Text>
      )}
      {actionButton && <Stack marginTop="xs3">{actionButton}</Stack>}
    </Styled.MessageContainer>
  );
};

const getIcon = (type: ToastType) => {
  switch (type) {
    case 'info':
      return <InfoIcon color="iconInfo" customFill={true} />;
    case 'success':
      return <SuccessIcon color="iconSuccess" customFill={true} />;
    case 'error':
      return <ErrorIconRound color="iconDanger" customFill={true} />;
    case 'warning':
      return <WarningIcon color="iconWarning" customFill={true} />;
    default:
      return null;
  }
};

export const Toast = ({
  type,
  title,
  description,
  actionButton,
  onClose,
  dismissable = true,
  closeButtonProps,
}: ToastProps) => (
  <Styled.ToastContainer data-test-id="alert-message" type={type}>
    <Styled.ToastIcon>{getIcon(type)}</Styled.ToastIcon>
    <Styled.ToastBody>
      <ToastMessage
        actionButton={actionButton}
        description={description}
        title={title}
      />
      {dismissable && (
        <IconButton
          data-test-id="alert-window-close-button"
          onClick={onClose}
          {...closeButtonProps}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Styled.ToastBody>
  </Styled.ToastContainer>
);
